// removed by extract-text-webpack-plugin
module.exports = {"block":"_3W6lBmp93rZAtImL3K6YIi","zebra":"_1dX5UdeUbd_X_nd3BC7vrl","yellow":"_3riBHnvZbfgM2oP9GgIDuO","darkgray":"Kuzn3-nRYT9dnEmE6e4Cm","lightgray":"bYLVTds1kKXB3exUCIovv","heading":"_3okRH4etTO06sJuGx6rzzI","list":"_37cK3NJmfoIfFIQvu5Ut_2","project":"_2nThfuaiw_ooqbmV2jAH0E","is-on-screen":"_1zeRNYVYmGPSx8QYIY98U9","external":"_16g7akpF74_WLUM5eAC9Dj","button":"_1jRctxewW2u8V5HSz_Vies"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectListBlock/ProjectListBlock.module.scss
// module id = 799
// module chunks = 0